import React, { Fragment } from 'react';

import { Breadcrumb } from 'antd';
import routePaths from 'config/routes';
import Link from 'src/components/Link';
import { IBreadCrumb } from 'src/shared/models';

export const renderConsumerBreadcrumbs = (
  _pathname: string,
  breadCrumbRoutes: IBreadCrumb[]
) => {
  const allowedRoutes = [
    routePaths.PAGES.EXPERIENCE_DETAIL,
    routePaths.PAGES.CHALLENGE_DETAIL,
    routePaths.PAGES.EXPERIENCE,
    routePaths.PAGES.CHALLENGE,
  ];
  if (allowedRoutes.indexOf(_pathname) <= -1) return <Fragment />;
  if (allowedRoutes.indexOf(_pathname) <= 1)
    return (
      <div className="breadcrumb-con">
        <Breadcrumb separator=">">
          {breadCrumbRoutes
            .filter(({ pathRoute }) => pathRoute !== routePaths.INDEX)
            .map(({ pathRoute, pathName }, index) => (
              <Breadcrumb.Item key={index}>
                {BreadcrumbTitle(
                  pathName,
                  pathRoute,
                  index == breadCrumbRoutes.length - 1
                )}
              </Breadcrumb.Item>
            ))}
        </Breadcrumb>
      </div>
    );
  if (allowedRoutes.indexOf(_pathname) > 1)
    return (
      <div className="breadcrumb-sticky">
        <div className={`container challengePage experiencesPage`}>
          <div className="breadcrumb-con">
            <div className="breadcrumbContainerExp">
              <Breadcrumb separator=">">
                {breadCrumbRoutes
                  // .filter(({ pathRoute }) => pathRoute !== routePaths.INDEX)
                  .map(({ pathRoute, pathName }, index) => (
                    <Breadcrumb.Item key={index}>
                      {BreadcrumbTitle(
                        pathName,
                        pathRoute,
                        index == breadCrumbRoutes.length - 1
                      )}
                    </Breadcrumb.Item>
                  ))}
              </Breadcrumb>
            </div>
          </div>
        </div>
      </div>
    );
};

const BreadcrumbTitle = (
  pathName: string,
  pathRoute: string,
  isLatest: boolean
) => {
  const applyLink = pathRoute.length > 0 && !isLatest;
  const title = <a className="breadcrumb-link">{pathName}</a>;

  return applyLink ? <Link href={pathRoute}>{title}</Link> : title;
};
